import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import _ from 'lodash'
import moment from 'moment'

import api from '../../../services/api'
import { DAILY_LOG_TYPE_LIST } from '../../../constants/dailyLog'
import useModal from '../../../hooks/useModal'
import Utils from '../../../utils'

import * as S from '../Modal.styles'
import { BasicRadioButtonsGroup } from '../../Buttons'
import { BasicTextFieldForForm } from '../../InputBoxes'
import { CompleteBtn } from '../../Buttons'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import { TimeField } from '@mui/x-date-pickers/TimeField'
import Checkbox from '@mui/material/Checkbox'

import { ReactComponent as CloseIcon } from '../../../assets/images/close_delete_icon.svg'

export default function UpdateDailyLogModal(props) {
  const { control, handleSubmit, watch } = useForm()
  const { openModal, closeModal } = useModal()
  const [dailyLogTypeList, setDailyLogTypeList] = useState([])
  const watchFields = watch()
  const dailyLogContents = _.find(props.dailyLogContentsList, { dailyLogId: props.dailyLogId })
  const watchLogType = watch('logType', dailyLogContents?.dailyLogTypeNameEn || 'study')
  const logOn = props.logOn

  useEffect(() => {
    async function fetchDailyLogTypeList() {
      let list = []
      for (const dailyLogType of DAILY_LOG_TYPE_LIST) {
        list.push({
          typeId: dailyLogType.dailyLogTypeId,
          type: dailyLogType.dailyLogTypeNameEn,
          nameKo: dailyLogType.dailyLogTypeNameKo
        })
      }
      setDailyLogTypeList(list)
    }

    fetchDailyLogTypeList()
  }, [])

  /**
   * 데일리 로그를 추가한다.
   */
  async function addDailyLog(data) {
    let { startOn, endOn, logType, focusTimeSec, contents, isFocusRateExcluded } = data
    if (logType !== 'study') focusTimeSec = null
    if (logType === 'rest') contents = '휴식'
    if (logType === 'meal') contents = '식사'
    if (logType === 'attendance') contents = '출석'

    await api.post(`/daily-logs/${logOn}`
      , {
        contents,
        dailyLogTypeId: Utils.getDailyLogTypeIdByTypeNameEn(logType),
        startOn: moment(startOn).format('YYYY-MM-DD HH:mm:ss'),
        endOn: moment(endOn).format('YYYY-MM-DD HH:mm:ss'),
        focusTimeSec: focusTimeSec
          ? (focusTimeSec.hours() * 3600) + (focusTimeSec.minutes() * 60) + focusTimeSec.seconds()
          : null,
        isFocusRateExcluded,
      })
      .then(async result => {
        closeModal()
        props.setDailyLogContentsList(result.data.dailyLogContentsList)
        if (props.isMain && props.setStatics) await updateTodayStudy()
      })
      .catch(e => {
        console.error(e)
        const props = {
          type: 'alert',
          props: {
            isError: true,
            contents: e.response?.data.message || e.message
          }
        }
        openModal(props)
      })

    if (props.setDailyLogList) {
      await api.get('/daily-logs', { params: { page: props.currentPage, limit: props.limit }})
        .then(result => props.setDailyLogList(result.data))
        .catch(e => {
          console.error(e)
          const props = {
            type: 'alert',
            props: {
              isError: true,
              contents: e.response?.data.message || e.message
            }
          }
          openModal(props)
        })
    }
  }

  /**
   * 데일리 로그를 수정한다.
   */
  async function modifyDailyLog(data) {
    let { startOn, endOn, logType, focusTimeSec, contents, isFocusRateExcluded } = data
    if (logType !== 'study') focusTimeSec = null
    if (logType === 'rest') contents = '휴식'
    if (logType === 'meal') contents = '식사'
    if (logType === 'attendance') contents = '출석'

    api.put(`daily-logs/${logOn}/${props.dailyLogId}`
      , {
        contents,
        dailyLogTypeId: Utils.getDailyLogTypeIdByTypeNameEn(logType),
        startOn: moment(startOn).format('YYYY-MM-DD HH:mm:ss'),
        endOn: moment(endOn).format('YYYY-MM-DD HH:mm:ss'),
        focusTimeSec: focusTimeSec ? (focusTimeSec.hours() * 3600) + (focusTimeSec.minutes() * 60) + focusTimeSec.seconds() : null,
        isFocusRateExcluded,
      })
      .then(async result => {
        props.setDailyLogContentsList(result.data.dailyLogContentsList)
        if (props.isMain && props.setStatics) await updateTodayStudy()
        closeModal()
      })
      .catch(e => {
        console.error(e)
        const props = {
          type: 'alert',
          props: {
            isError: true,
            contents: e.response?.data.message || e.message
          }
        }
        openModal(props)
      })
  }

  /**
   * 메인 페이지의 '오늘의 스터디(이번 주 스터디)' 데이터를 업데이트한다.
   */
  async function updateTodayStudy() {
    const reportTypeId = await api.get(`/reports/infos/types/${logOn}`)
      .then(result => result.data.reportTypeList[0].reportTypeId || '')
      .catch(e => {
        console.error(e)
        const props = {
          type: 'alert',
          props: {
            isError: true,
            contents: e.response?.data.message || e.message
          }
        }
        openModal(props)
      })

    await api.get(`/reports/infos/performances/${logOn}`, { params: { reportTypeId }})
      .then(result => { props.setStatics(result.data.statics) })
      .catch(e => {
        console.error(e)
        const props = {
          type: 'alert',
          props: {
            isError: true,
            contents: e.response?.data.message || e.message
          }
        }
        openModal(props)
      })
  }

  return (
    <>
      <S.Background />
      <S.ModalBox height='420px' width='400px'>
        <CloseIcon
          className='close-icon'
          width='25px'
          onClick={closeModal}
        />
        <S.ModalContents width='85%' height='80%'>
          <S.Title>{ props.isModify ? '한 일 수정' : '한 일 추가'}</S.Title>
          <BasicRadioButtonsGroup
            name='logType'
            control={control}
            defaultValue={dailyLogContents?.dailyLogTypeNameEn || 'study'}
            itemList={dailyLogTypeList}
            style={{ flex: 1 }}
          />
          <S.FlexContainer>
            <Controller
              control={control}
              defaultValue={dailyLogContents?.startOn
                ? moment(dailyLogContents?.startOn)
                : moment(props.logOn)
                  .startOf('day')
                  .set({ 'hour': moment().hour(), 'minute': moment().minute(), 'second': moment().second() })
                  .add(-1, 'hour')}
              name='startOn'
              rules={{
                validate: (v) => {
                  if (moment(v).isAfter(moment())) return '미래일 수 없습니다.'
                  if (moment(v).isAfter(moment(watchFields.endOn))) return '종료 시간보다 큽니다.'
                  if (moment(v).isSameOrBefore(moment(props.logOn).add(-1, 'days'))) return '하루 전까지 가능합니다.'
                  if (moment(v).isAfter(moment(props.logOn).add(1, 'days').hour(5))) return '다음날 오전 5시까지 가능합니다.'
                  return true
                }
              }}
              render={({ field, fieldState}) => (
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DateTimePicker
                    defaultValue={
                      dailyLogContents?.startOn
                        ? moment(dailyLogContents?.startOn)
                        : moment(props.logOn)
                          .startOf('day')
                          .set({ 'hour': moment().hour(),'minute': moment().minute(), 'second': moment().second() })
                          .add(-1, 'hour')
                    }
                    disableFuture
                    format='DD일 HH:mm:ss'
                    inputRef={field.ref}
                    label='시작 시간'
                    minDateTime={moment(props.logOn).add(-1, 'days')}
                    maxDateTime={moment(props.logOn).add(1, 'days').hour(5)}
                    onChange={field.onChange}
                    slotProps={{
                      textField: {
                        size: 'small',
                        error: !!fieldState.error,
                        helperText: fieldState.error?.message
                      }
                    }}
                    sx={{ width: '50%' }}
                    views={['day', 'hours', 'minutes']}
                  />
                </LocalizationProvider>
              )}
            />
            <S.Sign>~</S.Sign>
            <Controller
              control={control}
              defaultValue={
                dailyLogContents?.endOn
                  ? moment(dailyLogContents?.endOn)
                  : moment(props.logOn)
                    .startOf('day')
                    .set({ 'hour': moment().hour(), 'minute': moment().minute(), 'second': moment().second() })
              }
              name='endOn'
              rules={{
                validate: (v) => {
                  if (moment(v).isAfter(moment())) return '미래일 수 없습니다.'
                  if (watchFields.startOn && moment(v).isBefore(moment(watchFields.startOn))) return '시작 시간보다 작습니다.'
                  if (moment(v).isSameOrBefore(moment(props.logOn).add(-1, 'days'))) return '하루 전까지 가능합니다.'
                  if (moment(v).isAfter(moment(props.logOn).add(1, 'days').hour(5))) return '다음날 오전 5시까지 가능합니다.'
                  return true
                }
              }}
              render={({ field, fieldState}) => (
                <LocalizationProvider dateAdapter={AdapterMoment} >
                  <DateTimePicker
                    defaultValue={
                      dailyLogContents?.endOn
                        ? moment(dailyLogContents?.endOn)
                        : moment(props.logOn).startOf('day')
                          .set({ 'hour': moment().hour(), 'minute': moment().minute(), 'second': moment().second() })
                    }
                    disableFuture
                    format='DD일 HH:mm:ss'
                    inputRef={field.ref}
                    label='종료 시간'
                    maxDateTime={moment(props.logOn).add(1, 'days').hour(5)}
                    minDateTime={moment(props.logOn).add(-1, 'days')}
                    onChange={field.onChange}
                    slotProps={{
                      textField: {
                        size: 'small',
                        error: !!fieldState.error,
                        helperText: fieldState.error?.message
                      }
                    }}
                    sx={{ width: '50%' }}
                    views={['day', 'hours', 'minutes']}
                  />
                </LocalizationProvider>
              )}
            />
          </S.FlexContainer>
          {
            watchLogType === 'etc' && (
              <Controller
                name='isFocusRateExcluded'
                control={control}
                defaultValue={dailyLogContents?.isFocusRateExcluded || false}
                render={({ field }) => (
                  <div style={{ display: 'flex', alignItems: 'center', padding: '35px 0px 0px 0px' }}>
                    <Checkbox
                      {...field}
                      checked={field.value}
                      onChange={(e) => field.onChange(e.target.checked)}
                      style={{ padding: '10px 10px 10px 0px' }}
                      size='small'
                    />
                    <label>집중도 계산 제외</label>
                  </div>
                )}
              />
            )
          }
          {
            watchLogType === 'study' || watchLogType === 'etc'
              ?
              <S.FlexContainer style={{ marginTop: watchLogType === 'study' ? '35px' : '10px' }}>
                {
                  watchLogType === 'study' ?
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <Controller
                        control={control}
                        defaultValue={moment(`${logOn} ${String(parseInt((dailyLogContents?.focusTimeSec || 0) / 3600)).padStart(2, '0')}:${String(parseInt((dailyLogContents?.focusTimeSec || 0) % 3600 / 60)).padStart(2, '0')}:${String(parseInt((dailyLogContents?.focusTimeSec || 0) % 3600 % 60)).padStart(2, '0')}`)}
                        name='focusTimeSec'
                        rules={{
                          validate: (v) => {
                            if (watchFields.startOn && watchFields.endOn &&
                              moment(watchFields.endOn, 'YYYY-MM-DD HH:mm')
                                .diff(moment(watchFields.startOn, 'YYYY-MM-DD HH:mm'), 'seconds') < (v.hours() * 3600) + (v.minutes() * 60) + v.seconds()) {
                              return '집중 시간이 초과됩니다.'
                            }
                            return true
                          }
                        }}
                        render={({field, fieldState}) => (
                          <TimeField
                            defaultValue={moment()}
                            value={field.value}
                            format='HH:mm:ss'
                            inputRef={field.ref}
                            label='집중 시간'
                            onChange={field.onChange}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            slotProps={{
                              textField: {
                                size: 'small',
                              },
                            }}
                            style={{flex: 1, marginRight: '10px'}}
                          />
                        )}
                      />
                    </LocalizationProvider>
                    : <></>
                }
                <div style={{ flex: 2 }}>
                  <BasicTextFieldForForm
                    control={control}
                    defaultValue={dailyLogContents?.contents}
                    label='한 일'
                    name='contents'
                    minWidth='100%'
                    rules={{required: '한 일을 입력해 주세요'}}
                  />
                </div>
              </S.FlexContainer>
              : <></>
          }
          <S.BtnContainer>
            <CompleteBtn
              fontSize='1em'
              height='40px'
              width='100%'
              onClick={handleSubmit(props.isModify ? modifyDailyLog : addDailyLog)}
            >확인
            </CompleteBtn>
          </S.BtnContainer>
        </S.ModalContents>
      </S.ModalBox>
    </>
  )
}